import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Paper,
  useMediaQuery,
  TextField,
  Autocomplete,
} from "@mui/material";
import formatDateAndTime from "../../common/formatDateAndTime";
import toast from "react-hot-toast";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Commongrid from "../../common/Commongrid";
import { Plus, Upload, X } from "lucide-react";
import { createFilterOptions } from "@mui/material/Autocomplete";
import { useSelector } from "react-redux";
import formatDate from "../../common/Formatdate";
import Vieworderdetails from "./Vieworderdetails";
import moment from "moment";
import getactions from "../../common/getactions";
import DaterangePicker from "../../common/Daterangepicker";
import { sub } from "date-fns";
import ExportWorkOrderModal from "./Exportworkordermodal";
import { Download as DownloadIcon } from "lucide-react";

function createData(
  id,
  serviceCode,
  serviceType,
  subType,
  serviceStatus,
  paymentStatus,
  billingAmount,
  totalCostToCompany,
  outstandingBalance,
  licensePlate,
  vehicleName,
  vehicleGroupName,
  odometerReading,
  endingOdometer,
  isDeliveryAgentAssigned,
  isPickupAgentAssigned,
  createdAt,
  cityId,
  hubId,
  createdBy,
  // scheduledStartDate,
  // reportedOn,
) {
  return {
    id,
    serviceCode,
    serviceType,
    subType,
    serviceStatus,
    paymentStatus,
    billingAmount,
    totalCostToCompany,
    outstandingBalance,
    licensePlate,
    vehicleName,
    vehicleGroupName,
    odometerReading,
    endingOdometer,
    isDeliveryAgentAssigned,
    isPickupAgentAssigned,
    createdAt,
    cityId,
    hubId,
    createdBy,
    // scheduledStartDate,
    // reportedOn,
  };
}

const Workorderdashboard = ({ setActiveItem }) => {
  const cities = useSelector((state) => state?.cities?.citiesData);
  const querydisplay = new URLSearchParams(window.location.search).get(
    "display",
  );
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  let token = localStorage.getItem("token");
  const profile = JSON.parse(localStorage.getItem("profile"));
  const actionsToAccess = getactions(profile?.roles, profile?.actions);
  const isMobile = useMediaQuery("(max-width:768px)");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [openTab, setOpenTab] = useState(false);
  const [allWorkOrdersList, setAllWorkOrdersList] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  const workorderType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.workorderType;
  const workorderStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.workorderStatus;
  const workorderStatusValue = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.workorderStatus;
  delete workorderStatusValue?.inverted;
  const workorderTypeValues = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.workorderType;
  delete workorderTypeValues?.inverted;
  const helpdeskTicketPriority = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.helpdeskTicketPriority;
  const [vehicleFilterListings, setVehicleFilterListings] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [vehicleId, setVehicleId] = useState(null);
  const [copied, setCopied] = useState(false);
  const catalogRoles = JSON.parse(localStorage.getItem("catalogValues"))?.role
    ?.inverted?.franchiseAdmin;
  const catalogRActions = JSON.parse(localStorage.getItem("catalogValues"))
    ?.action?.inverted?.viewMyCityBookings;
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 20,
  });
  const [searchVelues, setSearchvalues] = useState("");
  const [listofSearchValues, setListofSearchValues] = useState([]);
  const [selectSearchValues, setSelectSearchValues] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [listLoading, setListLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({});
  const [getAllHubsListData, setGetAllHubsListData] = useState(null);
  const [overAllDetailsforWorkOrder, setOverAllDetailsforWorkOrder] =
    useState(null);
  const [workOrderStatusFilter, setWorkOrderStatusFilter] = useState("");
  const [workOrderTypesFilter, setWorkOrderTypesFilter] = useState("");
  const [isPaymentPendingFilter, setIsPaymentPendingFilter] = useState("");
  const [subTypeFilter, setSubTypeFilter] = useState("");
  const [cityFilter, setCityFilter] = useState(null);
  const [openExportModal, setOpenExportModal] = useState(false);
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
  oneMonthAgo.setHours(0, 0, 0, 0);
  const [selectionRange, setSelectionRange] = useState({
    startDate: oneMonthAgo,
    endDate: today,
    key: "selection",
  });

  const getAllHubsList = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/hubs?limit=1000`);
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setGetAllHubsListData(data?.entities?.rows);
      }
    } catch (error) {
      console.error("Error fetching City Names:", error);
    }
  };

  useEffect(() => {
    getAllHubsList();
  }, []);

  const columns = [
    {
      field: "id",
      headerName: "Id",
      minWidth: 40,
      align: "start",
      sortable: false,
    },
    {
      field: "serviceCode",
      headerName: "Tracking Id",
      minWidth: 200,
      align: "start",
      sortable: false,
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center", // 👈 center vertically
            justifyContent: "center",
            gap: 1,
            width: "100%",
          }}
        >
          <span>{params.value || "-"}</span>

          {params.value && (
            <ContentCopyIcon
              sx={{
                fontSize: 18,
                cursor: "pointer",
                color: copied === params.value ? "green" : "grey",
                transition: "color 0.2s",
              }}
              onClick={(e) => {
                e.stopPropagation();
                navigator.clipboard.writeText(params.value);
                setCopied(params.value);
                setTimeout(() => setCopied(false), 1500);
              }}
            />
          )}
        </Box>
      ),
    },
    {
      field: "serviceType",
      headerName: "Service Type",
      minWidth: 150,
      align: "start",
      sortable: false,
    },
    {
      field: "subType",
      headerName: "Sub Type",
      minWidth: 150,
      align: "start",
      sortable: false,
    },
    {
      field: "serviceStatus",
      headerName: "Service Status",
      minWidth: 150,
      align: "start",
      sortable: false,
    },
    {
      field: "paymentStatus",
      headerName: "Payment Status",
      minWidth: 150,
      align: "start",
      sortable: false,
      renderCell: (params) => {
        const status = params.value;

        const color =
          status === "Payment Completed"
            ? "green"
            : status === "Payment Pending"
              ? "blue"
              : "#0a0aa8ff";

        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <span style={{ color, fontWeight: 700 }}>
              {params.value || "-"}
            </span>
          </Box>
        );
      },
    },
    {
      field: "billingAmount",
      headerName: "Billing Amount",
      minWidth: 180,
      align: "start",
      sortable: false,
    },
    {
      field: "totalCostToCompany",
      headerName: "Total Cost To Company",
      minWidth: 180,
      align: "start",
      sortable: false,
    },
    {
      field: "outstandingBalance",
      headerName: "Outstanding Balance",
      minWidth: 180,
      align: "start",
      sortable: false,
      renderCell: (params) => (
        <Box
          sx={{
            color: "rgb(194, 11, 11)",
            px: 1,
            py: 0.5,
            borderRadius: 1,
            textAlign: "start",
            width: "100%",
          }}
        >
          {params.value || "-"}
        </Box>
      ),
    },
    // {
    //   field: "priorityId",
    //   headerName: "Priority",
    //   minWidth: 180,
    //   align: "start",
    //   sortable: false,
    //   renderCell: (params) =>
    //     params.value === "Critical" ? (
    //       <Box
    //         sx={{
    //           color: "#fa1805",
    //           fontWeight: 700,
    //           px: 1,
    //           py: 0.5,
    //           borderRadius: 1,
    //           textAlign: "center",
    //           width: "100%",
    //         }}
    //       >
    //         {params.value || "-"}
    //       </Box>
    //     ) : (
    //       <Box
    //         sx={{
    //           color: "#faee05",
    //           fontWeight: 700,
    //           px: 1,
    //           py: 0.5,
    //           borderRadius: 1,
    //           textAlign: "center",
    //           width: "100%",
    //         }}
    //       >
    //         {params.value || "-"}
    //       </Box>
    //     ),
    // },
    {
      field: "licensePlate",
      headerName: "Vehicle No",
      minWidth: 190,
      align: "start",
      sortable: false,
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center", // 👈 center vertically
            justifyContent: "center",
            gap: 1,
            width: "100%",
          }}
        >
          <span>{params.value || "-"}</span>

          {params.value && (
            <ContentCopyIcon
              sx={{
                fontSize: 18,
                cursor: "pointer",
                color: copied === params.value ? "green" : "grey",
                transition: "color 0.2s",
              }}
              onClick={(e) => {
                e.stopPropagation();
                navigator.clipboard.writeText(params.value);
                setCopied(params.value);
                setTimeout(() => setCopied(false), 1500);
              }}
            />
          )}
        </Box>
      ),
    },
    {
      field: "vehicleName",
      headerName: "Vehicle Name",
      minWidth: 150,
      align: "start",
      sortable: false,
    },
    {
      field: "vehicleGroupName",
      headerName: "Vehicle Group Name",
      minWidth: 150,
      align: "start",
      sortable: false,
    },
    {
      field: "odometerReading",
      headerName: "Start Odometer Reading",
      minWidth: 150,
      align: "start",
      sortable: false,
    },
    {
      field: "endingOdometer",
      headerName: "End Odometer Reading",
      minWidth: 150,
      align: "start",
      sortable: false,
    },
    {
      field: "isDeliveryAgentAssigned",
      headerName: "Delivery Agent Assigned",
      minWidth: 150,
      align: "start",
      sortable: false,
      renderCell: (params) => {
        const status = params.value;

        const color =
          status === "Yes" ? "green" : status === "No" ? "red" : "#0a0aa8ff";

        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <span style={{ color, fontWeight: 700 }}>
              {params.value || "-"}
            </span>
          </Box>
        );
      },
    },
    {
      field: "isPickupAgentAssigned",
      headerName: "Pickup Agent Assigned",
      minWidth: 150,
      align: "start",
      sortable: false,
      renderCell: (params) => {
        const status = params.value;

        const color =
          status === "Yes" ? "green" : status === "No" ? "red" : "#0a0aa8ff";

        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <span style={{ color, fontWeight: 700 }}>
              {params.value || "-"}
            </span>
          </Box>
        );
      },
    },
    {
      field: "createdAt",
      headerName: "Work Order Ageing",
      minWidth: 150,
      align: "start",
      sortable: false,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              color: "red",
            }}
          >
            <span style={{ fontWeight: 700 }}>{params.value || "-"}</span>
          </Box>
        );
      },
    },
    {
      field: "cityId",
      headerName: "City",
      minWidth: 140,
      align: "start",
    },
    {
      field: "hubId",
      headerName: "Hub",
      minWidth: 100,
      align: "start",
    },
    {
      field: "createdBy",
      headerName: "Created By",
      minWidth: 200,
      align: "start",
    },
    // {
    //   field: "scheduledStartDate",
    //   headerName: "Scheduled Start Date",
    //   minWidth: 190,
    //   align: "start",
    //   renderCell: (params) => (
    //     <Box
    //       sx={{
    //         color: "#292dec",
    //         fontWeight: 700,
    //         px: 1,
    //         py: 0.5,
    //         borderRadius: 1,
    //         textAlign: "center",
    //         width: "100%",
    //       }}
    //     >
    //       {params.value || "-"}
    //     </Box>
    //   ),
    // },
    // {
    //   field: "reportedOn",
    //   headerName: "Reported On",
    //   minWidth: 190,
    //   align: "start",
    // },
  ];

  const rows =
    (allWorkOrdersList &&
      allWorkOrdersList?.map((item) =>
        createData(
          item?.id,
          item?.serviceCode || "-",
          workorderType[item?.serviceType] || "-",
          item?.subType || "-",
          workorderStatus[item?.serviceStatus] || "-",
          item?.isPaymentPending ? "Payment Pending" : "Payment Completed",
          item?.billingDetails?.billingAmount
            ? "Rs : " + item?.billingDetails?.billingAmount
            : "Rs : " + 0,
          item?.billingDetails?.costToCompany
            ? "Rs : " + item?.billingDetails?.costToCompany
            : "Rs : " + 0,
          item?.outstandingBalance
            ? "Rs : " + item?.outstandingBalance
            : "Rs : " + 0,
          item?.licensePlate || "/",
          item?.vehicleInfo?.vehicleGroupText,
          item?.vehicleInfo?.name || "-",
          item?.odometerReading + "/ Km" || "-",
          item?.endingOdometer + "/ Km" || "-",
          item?.isDeliveryAgentAssigned ? "Yes" : "No",
          item?.isPickupAgentAssigned ? "Yes" : "No",
          (item?.endDate &&
            item?.startDate &&
            moment(item?.endDate).diff(moment(item?.startDate), "days") +
              " Days") ||
            "-",
          cities[item?.cityId],
          getAllHubsListData.filter((hub) => hub?.id === item?.hubId)[0]
            ?.hubName || "-",
          item?.createdAt || "-",
          // helpdeskTicketPriority[item?.priorityId] || "-",
          // formatDate(item?.scheduledStartDate),
          // formatDate(item?.reportedOn),
        ),
      )) ||
    [];

  useEffect(() => {
    if (querydisplay) {
      setOpenTab(true);
    }
  }, [querydisplay]);

  useEffect(() => {
    if (searchVelues.length > 3) {
      searchOnTheFilterBy();
    }
  }, [searchVelues]);

  const getVehicleData = async () => {
    let query = "";
    if (
      profile?.roles.includes(Number(catalogRoles)) ||
      profile?.actions.includes(Number(catalogRActions))
    ) {
      query += `&cityId=${profile?.cityId}`;
    }
    try {
      const response = await fetch(
        `${apiUrl}/api/vehicles?limit=1000${query}`,
        {
          method: "GET",
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setVehicleFilterListings(data?.entities?.rows);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching get vehicle listings:", error);
    }
  };

  useEffect(() => {
    getVehicleData();
  }, []);

  const searchOnTheFilterBy = async () => {
    if (!token) {
      return toast.error("Session Expired Close all the tab and signin again");
    }
    let query = "";
    if (
      profile?.roles.includes(Number(catalogRoles)) ||
      profile?.actions.includes(Number(catalogRActions))
    ) {
      query += `&cityId=${profile?.cityId}`;
    }
    setListLoading(true);
    try {
      const response = await fetch(
        `${apiUrl}/api/advancesearch/search?key=vehicleServices&queryStr=${searchVelues}${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setListLoading(false);
        setListofSearchValues(data?.dataValues);
      } else {
        setListLoading(false);
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  useEffect(() => {
    setPage(0);
    getAllIssues(0);
  }, [
    workOrderStatusFilter,
    workOrderTypesFilter,
    isPaymentPendingFilter,
    cityFilter,
    subTypeFilter,
  ]);

  const getAllIssues = async (
    customPage = page,
    customRowsPerPage = rowsPerPage,
  ) => {
    setLoading(true);
    const offset = (customPage ?? 0) * (customRowsPerPage ?? rowsPerPage);
    let query = "";

    // if (
    //   profile?.roles.includes(Number(catalogRoles)) ||
    //   profile?.actions.includes(Number(catalogRActions))
    // ) {
    //   query += `&cityId=${profile?.cityId}`;
    // }
    // else if (profile?.actions.includes(Number(catalogRActions))) {
    //   query += `&cityId=${profile?.cityId}`;
    // }

    if (selectSearchValues != null && selectSearchValues !== "") {
      query += `&id=${selectSearchValues}`;
    }

    if (workOrderStatusFilter) {
      query += `&serviceStatus=${workOrderStatusFilter}`;
    }

    if (workOrderTypesFilter) {
      query += `&serviceType=${workOrderTypesFilter}`;
    }

    if (subTypeFilter) {
      query += `&subType=${subTypeFilter}`;
    }

    if (vehicleId) {
      query += `&vehicleId=${vehicleId}`;
    }

    if (isPaymentPendingFilter === "true") {
      query += `&isPaymentPending=true`;
    } else if (isPaymentPendingFilter === "false") {
      query += `&isPaymentPending=false`;
    }

    if (cityFilter) {
      query += `&cityId=${cityFilter}`;
    } else if (
      profile?.roles.includes(Number(catalogRoles)) ||
      profile?.actions.includes(Number(catalogRActions))
    ) {
      query += `&cityId=${profile?.cityId}`;
    }

    try {
      const response = await fetch(
        `${apiUrl}/api/vehicleservices?limit=${customRowsPerPage}&offset=${offset}${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        setAllWorkOrdersList(data?.entities?.rows);
        setTotalCount(data?.entities?.count || 0);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  useEffect(() => {
    if (selectionRange?.startDate && selectionRange?.endDate) {
      getAllIssuesByDateFilter(0);
    }
  }, [selectionRange?.endDate]);

  function formatDateForApi(date) {
    const pad = (n) => (n < 10 ? "0" + n : n);
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  const getAllIssuesByDateFilter = async (
    customPage = page,
    customRowsPerPage = rowsPerPage,
  ) => {
    const formattedStartDate = formatDateForApi(selectionRange?.startDate);
    const formattedEndDate = formatDateForApi(selectionRange?.endDate);
    setLoading(true);
    const offset = (customPage ?? 0) * (customRowsPerPage ?? rowsPerPage);
    let query = "";

    if (selectionRange?.startDate && selectionRange?.endDate) {
      query += `&id=${selectSearchValues}`;
    }

    if (
      profile?.roles.includes(Number(catalogRoles)) ||
      profile?.actions.includes(Number(catalogRActions))
    ) {
      query += `&cityId=${profile?.cityId}`;
    }

    try {
      const response = await fetch(
        `${apiUrl}/api/vehicleservices/date-filter?startDate=${formattedStartDate}&endDate=${formattedEndDate}${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        setAllWorkOrdersList(data?.dataValues?.rows);
        setTotalCount(data?.dataValues?.count || 0);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  const handleViewClick = (row) => {
    if (actionsToAccess?.includes("Add Update Workorder")) {
      setSelectedRow(row);
      setOpenTab(true);
    } else {
      return toast.error("You don't have access to view and update details", {
        position: "top-end",
        style: {
          background: "red",
          color: "white",
          marginBottom: "50px",
        },
      });
    }
  };

  const handleReset = () => {
    setPaginationModel({ page: 0, pageSize: 20 });
    setSearchvalues("");
    setVehicleId(null);
    setSelectSearchValues(null);
    setListofSearchValues([]);
  };

  useEffect(() => {
    getAllIssues(paginationModel.page, paginationModel.pageSize);
  }, [paginationModel, selectSearchValues, vehicleId]);

  const handleChange = async (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleGenerate = async () => {
    if (!form?.filtertype || !form?.startDate || !form?.endDate) {
      return toast.error("Fill Details to download report", {
        position: "top-center",
        style: {
          background: "white", // override background
          color: "red",
          fontWeight: "medium",
          marginBottom: "20px",
        },
      });
    }

    try {
      const endpoint = `/api/reports/vehicle-issues?datefilterType=${
        form.filtertype
      }&startDate=${form.startDate + "T00:00"}&endDate=${
        form.endDate + "T23:59"
      }`;

      if (!endpoint) {
        toast.error("Report endpoint not defined!");
        return;
      }

      let query = "";

      if (
        profile?.roles.includes(Number(catalogRoles)) ||
        profile?.actions.includes(Number(catalogRActions))
      ) {
        query += `&cityId=${profile?.cityId}`;
      }

      const url = `${apiUrl}${endpoint}${query}`;
      const response = await toast.promise(
        fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }),
        {
          loading: "Generating report...",
          success: "Report generated successfully!",
          error: "Failed to generate report!",
        },
      );

      const data = await response.json();
      if (data?.statusCode === "0100" && data?.entities?.result === -1) {
        toast.error(data?.entities?.msg, {
          position: "top-center",
          style: {
            background: "white", // override background
            color: "red",
            fontWeight: "medium",
            marginBottom: "20px",
          },
        });
      } else {
        setOpen(false);
        setForm({});
        window.open(data.entities.Location, "_blank");
        toast.success("Report generated successfully", {
          position: "top-center",
          style: {
            background: "blue", // override background
            color: "white",
            fontWeight: "medium",
            marginBottom: "20px",
          },
        });
      }
    } catch (error) {
      console.error("Error generating report:", error);
    }
  };

  const filterOptions = createFilterOptions({
    stringify: (option) =>
      `${option.id} ${option.name} ${option.licensePlate ?? ""}`,
  });

  useEffect(() => {
    getWorkOrderOverAllDetails();
  }, []);

  const getWorkOrderOverAllDetails = async (id) => {
    if (!token) {
      return toast.error("Session Expired Close all the tab and signin again");
    }
    let query = "";
    if (
      profile?.roles.includes(Number(catalogRoles)) ||
      profile?.actions.includes(Number(catalogRActions))
    ) {
      query += `cityId=${profile?.cityId}`;
    }
    try {
      const response = await fetch(
        `${apiUrl}/api/vehicleservices/fetch-card-summary?${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setOverAllDetailsforWorkOrder(data?.dataValues);
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  return (
    <>
      {!openTab ? (
        <>
          <div className="p-4">
            <div className="flex justify-between">
              <h1 className="text-xl md:text-2xl font-bold">
                View all Work Orders
              </h1>
              <div className="flex items-center gap-3">
              <button
                onClick={() => {
                  getAllIssues();
                  setPaginationModel({ page: 0, pageSize: 20 });
                }}
                class="p-5 rounded-full backdrop-blur-lg border border-green-500/20 bg-gradient-to-tr from-white/60 to-white/40 shadow-lg hover:shadow-2xl hover:shadow-green-500/30 hover:scale-110 hover:rotate-2 active:scale-95 active:rotate-0 transition-all duration-300 ease-out cursor-pointer hover:border-green-500/50 hover:bg-gradient-to-tr hover:from-green-500/10 hover:to-white/40 group relative overflow-hidden"
              >
                <div class="absolute inset-0 bg-gradient-to-r from-transparent via-green-400/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700 ease-out"></div>
                <div class="relative z-10">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="100"
                    height="100"
                    viewBox="0 0 30 30"
                    className="w-4 h-4"
                  >
                    <path d="M 15 3 C 12.031398 3 9.3028202 4.0834384 7.2070312 5.875 A 1.0001 1.0001 0 1 0 8.5058594 7.3945312 C 10.25407 5.9000929 12.516602 5 15 5 C 20.19656 5 24.450989 8.9379267 24.951172 14 L 22 14 L 26 20 L 30 14 L 26.949219 14 C 26.437925 7.8516588 21.277839 3 15 3 z M 4 10 L 0 16 L 3.0507812 16 C 3.562075 22.148341 8.7221607 27 15 27 C 17.968602 27 20.69718 25.916562 22.792969 24.125 A 1.0001 1.0001 0 1 0 21.494141 22.605469 C 19.74593 24.099907 17.483398 25 15 25 C 9.80344 25 5.5490109 21.062074 5.0488281 16 L 8 16 L 4 10 z"></path>
                  </svg>
                </div>
              </button>

              <button
                onClick={() => setOpenExportModal(true)}
                class="p-5 rounded-full backdrop-blur-lg border border-blue-500/20 bg-gradient-to-tr from-white/60 to-white/40 shadow-lg hover:shadow-2xl hover:shadow-blue-500/30 hover:scale-110 hover:rotate-2 active:scale-95 active:rotate-0 transition-all duration-300 ease-out cursor-pointer hover:border-blue-500/50 hover:bg-gradient-to-tr hover:from-blue-500/10 hover:to-white/40 group relative overflow-hidden ml-3"
              >
                <div class="absolute inset-0 bg-gradient-to-r from-transparent via-blue-400/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700 ease-out"></div>
                <div class="relative z-10">
                  <DownloadIcon className="w-4 h-4" />
                </div>
              </button>
              </div>
            </div>

            <ExportWorkOrderModal
              open={openExportModal}
              onClose={() => setOpenExportModal(false)}
              cities={cities}
              hubsList={getAllHubsListData}
              workorderTypeValues={workorderTypeValues}
              workorderStatusValue={workorderStatusValue}
              workorderType={workorderType}
              apiUrl={apiUrl}
              token={token}
            />
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-5 mb-6 mt-4">
              <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-blue-50 to-blue-100 border border-blue-200 p-5 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                <div className="absolute top-0 right-0 w-20 h-20 bg-blue-200 rounded-full opacity-20 -mr-8 -mt-8"></div>
                <p className="text-xs font-semibold text-blue-700 uppercase tracking-wider">
                  Total Service Completed
                </p>
                <h2 className="text-4xl font-bold text-blue-900 mt-4">
                  {overAllDetailsforWorkOrder?.totalWOServiceCompleted || 0}
                </h2>
              </div>

              <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-green-50 to-green-100 border border-green-200 p-5 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                <div className="absolute top-0 right-0 w-20 h-20 bg-green-200 rounded-full opacity-20 -mr-8 -mt-8"></div>
                <p className="text-xs font-semibold text-green-700 uppercase tracking-wider">
                  PMS Service Count
                </p>
                <h2 className="text-4xl font-bold text-green-900 mt-4">
                  {overAllDetailsforWorkOrder?.totalWOPMS || 0}
                </h2>
              </div>

              <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-indigo-50 to-indigo-100 border border-indigo-200 p-5 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                <div className="absolute top-0 right-0 w-20 h-20 bg-indigo-200 rounded-full opacity-20 -mr-8 -mt-8"></div>
                <p className="text-xs font-semibold text-indigo-700 uppercase tracking-wider">
                  Accident Service Count
                </p>
                <h2 className="text-4xl font-bold text-indigo-900 mt-4">
                  {overAllDetailsforWorkOrder?.totalWOAccidental || 0}
                </h2>
              </div>

              <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-red-50 to-red-100 border border-red-200 p-5 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                <div className="absolute top-0 right-0 w-20 h-20 bg-red-200 rounded-full opacity-20 -mr-8 -mt-8"></div>
                <p className="text-xs font-semibold text-red-700 uppercase tracking-wider">
                  Running Repair Count
                </p>
                <h2 className="text-4xl font-bold text-red-900 mt-4">
                  {overAllDetailsforWorkOrder?.totalWORunningRepair || 0}
                </h2>
              </div>

              <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-purple-50 to-purple-100 border border-purple-200 p-5 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                <div className="absolute top-0 right-0 w-20 h-20 bg-purple-200 rounded-full opacity-20 -mr-8 -mt-8"></div>
                <p className="text-xs font-semibold text-purple-700 uppercase tracking-wider">
                  Tinkering & Painting
                </p>
                <h2 className="text-4xl font-bold text-purple-900 mt-4">
                  {overAllDetailsforWorkOrder?.totalWOTinkiringAndPainting || 0}
                </h2>
              </div>

              <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-purple-50 to-purple-100 border border-purple-200 p-5 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                <div className="absolute top-0 right-0 w-20 h-20 bg-purple-200 rounded-full opacity-20 -mr-8 -mt-8"></div>
                <p className="text-xs font-semibold text-purple-700 uppercase tracking-wider">
                  Wear and Tear
                </p>
                <h2 className="text-4xl font-bold text-purple-900 mt-4">
                  {overAllDetailsforWorkOrder?.totalWOWearAndTear || 0}
                </h2>
              </div>

              <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-orange-50 to-orange-100 border border-orange-200 p-5 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                <div className="absolute top-0 right-0 w-20 h-20 bg-orange-200 rounded-full opacity-20 -mr-8 -mt-8"></div>
                <p className="text-xs font-semibold text-orange-700 uppercase tracking-wider">
                  Payment Pending
                </p>
                <h2 className="text-4xl font-bold text-orange-900 mt-4">
                  {overAllDetailsforWorkOrder?.totalWOPaymentPending || 0}
                </h2>
              </div>
            </div>
          </div>

          <div className="flex">
            {" "}
            {profile?.roles.includes(Number(catalogRoles)) ||
            profile?.actions.includes(Number(catalogRActions)) ? (
              <></>
            ) : (
              <div className="relative w-[400px] mx-4">
                <input
                  autoComplete="off"
                  placeholder="Search based on Tracking id and Vehicle No..."
                  className="input shadow-lg px-5 py-3 rounded-xl w-full outline-none"
                  name="search"
                  type="text"
                  value={searchVelues}
                  onChange={(e) => {
                    setSearchvalues(e.target.value);
                    setShowDropdown(true);
                  }}
                />

                {searchVelues && (
                  <button
                    type="button"
                    onClick={() => {
                      setSearchvalues("");
                      setSelectSearchValues(null);
                      setShowDropdown(false);
                      setListofSearchValues([]); // optional (if you want to clear suggestions)
                    }}
                    className="absolute top-3 right-10 text-gray-400 hover:text-black"
                  >
                    ✕
                  </button>
                )}

                {listLoading ? (
                  <svg
                    className="size-6 absolute top-3 right-3 animate-spin text-gray-500"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="blue"
                  >
                    <circle
                      cx="12"
                      cy="12"
                      r="9"
                      strokeWidth="1.5"
                      className="opacity-25"
                    />
                    <path
                      d="M21 12a9 9 0 0 1-9 9"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      className="opacity-75"
                    />
                  </svg>
                ) : (
                  <svg
                    className="size-6 absolute top-3 right-3 text-gray-500"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                      strokeLinejoin="round"
                      strokeLinecap="round"
                    />
                  </svg>
                )}

                {listofSearchValues?.length > 0 && (
                  <div className="absolute z-50 mt-2 w-full bg-white border border-gray-200 rounded-xl shadow-lg max-h-60 overflow-auto">
                    {listofSearchValues.map((item) => (
                      <div
                        key={item.id}
                        className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                        onClick={() => {
                          setSelectSearchValues(item.id);
                          setSearchvalues(
                            item.licensePlate + "-" + item?.serviceCode,
                          );
                          setShowDropdown(false); // 👈 CLOSE
                        }}
                      >
                        {item.licensePlate + "-" + item?.serviceCode}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
            <div className="p-1">
              <DaterangePicker
                selectionRange={selectionRange}
                setSelectionRange={setSelectionRange}
              />
            </div>
            <div className="flex gap-4 items-center">
              <div className="flex items-center gap-3">
                <select
                  value={isPaymentPendingFilter}
                  onChange={(e) => setIsPaymentPendingFilter(e.target.value)}
                  className="h-10 rounded-lg border border-gray-300 px-3 text-sm 
                   bg-white focus:outline-none focus:ring-2 
                   focus:ring-blue-500 focus:border-blue-500"
                >
                  <option value="">Select Payment Filter</option>
                  <option value={true}>Payment Pending</option>
                  <option value={false}>Payment Completed</option>
                </select>
              </div>              
              <select
                value={workOrderTypesFilter}
                onChange={(e) => setWorkOrderTypesFilter(e.target.value)}
                className="h-10 rounded-lg border border-gray-300 px-3 text-sm 
                   bg-white focus:outline-none focus:ring-2 
                   focus:ring-blue-500 focus:border-blue-500"
              >
                <option value="">Select Type Filter</option>
                {Object.entries(workorderTypeValues).map(([key, value]) => (
                  <option value={key}>{value}</option>
                ))}
              </select>
              {workOrderTypesFilter === workorderType.inverted?.wearAndTear && <select
                  value={subTypeFilter}
                  onChange={(e) => setSubTypeFilter(e.target.value)}
                  className="h-10 rounded-lg border border-gray-300 px-3 text-sm 
                   bg-white focus:outline-none focus:ring-2 
                   focus:ring-blue-500 focus:border-blue-500"
                >
                  <option value="">Select Sub-Type Filter</option>
                  <option value="Clutch">Clutch</option>
                  <option value="Tyres">Tyres</option>
                  <option value="Battery">Battery</option>
                  <option value="Wind Shield">Wind Shield</option>
                  <option value="Wheel Alignment / Balancing">Wheel Alignment / Balancing</option>

                </select>}

              {profile?.roles.includes(Number(catalogRoles)) ||
              profile?.actions.includes(Number(catalogRActions)) ? (
                <></>
              ) : (
                <select
                  value={cityFilter}
                  onChange={(e) => setCityFilter(e.target.value)}
                  className="h-10 rounded-lg border border-gray-300 px-3 text-sm 
                   bg-white focus:outline-none focus:ring-2 
                   focus:ring-blue-500 focus:border-blue-500"
                >
                  <option value="">Select City Filter</option>
                  {Object.entries(cities).map(([key, value]) => (
                    <option value={key}>{value}</option>
                  ))}
                </select>
              )}

              <select
                value={workOrderStatusFilter}
                onChange={(e) => setWorkOrderStatusFilter(e.target.value)}
                className="h-10 rounded-lg border border-gray-300 px-3 text-sm 
                   bg-white focus:outline-none focus:ring-2 
                   focus:ring-blue-500 focus:border-blue-500"
              >
                <option value="">Select Status Filter</option>
                {Object.entries(workorderStatusValue).map(([key, value]) => (
                  <option value={key}>{value}</option>
                ))}
              </select>
            </div>
            <button
              onClick={() => {
                setWorkOrderStatusFilter("");
                setWorkOrderTypesFilter("");
                setIsPaymentPendingFilter("");
                setSubTypeFilter("");
                setCityFilter(null);
                setSearchvalues("");
                setSelectSearchValues(null);
                setShowDropdown(false);
                setListofSearchValues([]);
                setPage(0);
                getAllIssues(0);
              }}
              className="ml-2 bg-gray-400 px-2 rounded text-white"
            >
              Clear
            </button>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 p-4">
            <div className="col-span-12">
              <Commongrid
                rows={rows}
                columns={columns}
                totalCount={totalCount}
                handleViewClick={handleViewClick}
                api={getAllIssues}
                setPaginationModel={setPaginationModel}
                paginationModel={paginationModel}
                loading={loading}
                disableColumnMenu={true}
              />
            </div>
            {/* <div className="col-span-3">
              <div className="bg-gradient-to-br from-slate-800 to-slate-700 text-white rounded-xl p-5 shadow">
                <h2 className="font-semibold mb-3">✨ AI Forecast</h2>

                <div className="space-y-4 text-sm">
                  <div>
                    <div className="flex justify-between">
                      <span>PMS (15 Vehicles)</span>
                      <b>$2400</b>
                    </div>
                    <div className="h-2 bg-slate-600 rounded mt-1">
                      <div className="h-2 bg-blue-500 rounded w-[60%]"></div>
                    </div>
                  </div>

                  <div>
                    <div className="flex justify-between">
                      <span>Part Failures</span>
                      <b>$650</b>
                    </div>
                    <div className="h-2 bg-slate-600 rounded mt-1">
                      <div className="h-2 bg-yellow-500 rounded w-[20%]"></div>
                    </div>
                  </div>

                  <div>
                    <div className="flex justify-between">
                      <span>Insurance Recovery</span>
                      <b>$3100</b>
                    </div>
                    <div className="h-2 bg-slate-600 rounded mt-1">
                      <div className="h-2 bg-green-500 rounded w-[85%]"></div>
                    </div>
                  </div>
                </div>

                <div className="mt-5 p-3 bg-white/10 rounded text-xs">
                  Bulk order <b>Brake Pads</b> to save 15%
                </div>
              </div>
            </div> */}
          </div>
        </>
      ) : (
        <>
          <Vieworderdetails
            setSearchvalues={setSearchvalues}
            selectedRow={selectedRow}
            setSelectSearchValues={setSelectSearchValues}
            setOpenTab={setOpenTab}
            getAllIssues={getAllIssues}
            setPaginationModel={setPaginationModel}
            workorderType={workorderType}
            helpdeskTicketPriority={helpdeskTicketPriority}
            workorderTypeValues={workorderTypeValues}
          />
        </>
      )}
    </>
  );
};

export default Workorderdashboard;